module.exports = __webpack_public_path__ + "assets/pdf/BN04-en-communicating-uncertainity.e215c364.pdf";